import React, { useEffect, useState } from "react";

const toNum = (s) => (s === "" ? null : Number(s));

// Percent input that accepts both "12,5" and "12.5" (number inputs drop comma decimals in id-ID locale).
export function PctInput({ value, onChange, placeholder, disabled, testid, className = "" }) {
  const ext = value == null || value === "" ? "" : String(value);
  const [raw, setRaw] = useState(ext.replace(".", ","));
  useEffect(() => { setRaw((r) => (toNum(r.replace(",", ".")) === toNum(ext) ? r : ext.replace(".", ","))); }, [ext]);
  const onInput = (e) => {
    let s = e.target.value.replace(/[^\d.,]/g, "").replace(".", ",");
    const [i, ...f] = s.split(",");
    s = f.length ? `${i},${f.join("").slice(0, 2)}` : i;
    setRaw(s);
    const n = s.replace(",", ".");
    if (n === "" || !Number.isNaN(Number(n))) onChange(n === "" ? null : Number(n));
  };
  return <input type="text" inputMode="decimal" disabled={disabled} placeholder={placeholder} value={raw} onChange={onInput} data-testid={testid}
    className={`rounded-lg border border-line px-2 py-1.5 text-sm outline-none focus:border-brand disabled:bg-slate-50 ${className}`} />;
}
